import { change } from 'redux-form'
import {
  PERSONAL_INFORMATION_FORM,
  ADDRESS_LINE1_PROPERTY,
  CITY_PROPERTY,
  STATE_PROPERTY,
  ZIP_CODE_PROPERTY
} from './constants'

export const handleChooseAddressSuggestion = ({ address1, city, state, zipCode }) => dispatch => {
  dispatch(change(PERSONAL_INFORMATION_FORM, ADDRESS_LINE1_PROPERTY, address1))
  dispatch(change(PERSONAL_INFORMATION_FORM, CITY_PROPERTY, city))
  dispatch(change(PERSONAL_INFORMATION_FORM, STATE_PROPERTY, state))
  dispatch(change(PERSONAL_INFORMATION_FORM, ZIP_CODE_PROPERTY, zipCode))
}
